import { render, staticRenderFns } from "./StudentReports.vue?vue&type=template&id=699254bc"
import script from "./StudentReports.vue?vue&type=script&lang=js"
export * from "./StudentReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports